import { render, staticRenderFns } from "./ModalSemAcesso.vue?vue&type=template&id=49efb631&"
import script from "./ModalSemAcesso.vue?vue&type=script&lang=js&"
export * from "./ModalSemAcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports